import { EnumProducts } from "services/caju/enums/enumProducts";
import { FORM_LOCAL_STORAGE_KEY } from "../consts";
import { FormikValues } from "formik";
import { IFormFromLocalStorage } from "../types";
import { IStep3FormValues } from "../step3/useStep3Form/iStep3FormValues";

export const getNextStep = (
  values: IStep3FormValues,
  employeesNumber: number | ""
) => {
  const {products} = values;

  if (employeesNumber && employeesNumber >= 1000) return 6

  if(employeesNumber && employeesNumber < 20) return 3

  const isOnlyMultibenefitsOrCajuMais = products.every(
    (product) =>
      product === EnumProducts.MULTIBENEFITS || product === EnumProducts.CAJU_MAIS || product === EnumProducts.AWARDS
  );

  const hasExpenses = !!products?.includes(EnumProducts.CORP_EXPENSES);
  const employeesLess499 = employeesNumber && (employeesNumber >= 20 && employeesNumber <= 499)

  const goesToStep7Employee = employeesNumber && (employeesNumber >= 20 && employeesNumber <= 999)

  const goesToStep7 = 
    (goesToStep7Employee && (isOnlyMultibenefitsOrCajuMais || products.length > 1)) ||
    (employeesLess499 && hasExpenses)

  if(goesToStep7) return 6

  return 4
};

export function getFormFromLocalStorage() {
  const rawFormFromLocalStorage = localStorage.getItem(FORM_LOCAL_STORAGE_KEY) || "{}";
  const formFromLocalStorage: IFormFromLocalStorage = JSON.parse(rawFormFromLocalStorage);

  return formFromLocalStorage;
}

export function saveFieldsOnLocalStorage(values: FormikValues) {
  const formFromLocalStorage = getFormFromLocalStorage();

  localStorage.setItem(
    FORM_LOCAL_STORAGE_KEY,
    JSON.stringify({ ...formFromLocalStorage, ...values })
  );
}
